/* Russian (UTF-8) initialisation for the jQuery UI date picker plugin. */
$.datepicker.regional['ru-RU'] = {
  closeText: 'Закрыть',
  prevText: '&#x3c;Пред',
  nextText: 'След&#x3e;',
  currentText: 'Сегодня',
  monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
  'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
  dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
  dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
  dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  weekHeader: 'Нед',
  dateFormat: currentCultureFormat.dateFormat,
  firstDay: currentCultureFormat.firstDay,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: '',
  dateseparator: currentCultureFormat.dateSeparator
};
$.timepicker.regional['ru-RU'] = {
  timeOnlyTitle: 'Выберите время',
  timeText: 'Время',
  hourText: 'Часы',
  minuteText: 'Минуты',
  secondText: 'Секунды',
  currentText: 'Сегодня',
  closeText: 'Закрыть',
  ampm: currentCultureFormat.ampm === "true",
  timeFormat: currentCultureFormat.timeFormat
};


/* English/US initialisation for the jQuery UI date picker plugin. */
$.datepicker.regional['en-US'] = {
  closeText: 'Done',
  prevText: 'Prev',
  nextText: 'Next',
  currentText: 'Today',
  monthNames: ['January,', 'February,', 'March,', 'April,', 'May,', 'June,',
  'July,', 'August,', 'September,', 'October,', 'November,', 'December,'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  weekHeader: 'Wk',
  dateFormat: currentCultureFormat.dateFormat,
  firstDay: currentCultureFormat.firstDay,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: '',
  dateseparator: currentCultureFormat.dateSeparator
};
$.timepicker.regional['en-US'] =
{
  timeFormat: currentCultureFormat.timeFormat,
  ampm: currentCultureFormat.ampm === "true"
};

/* English/UK initialisation for the jQuery UI date picker plugin. */
$.datepicker.regional['en-GB'] = {
  closeText: 'Done',
  prevText: 'Prev',
  nextText: 'Next',
  currentText: 'Today',
  monthNames: ['January,', 'February,', 'March,', 'April,', 'May,', 'June,',
  'July,', 'August,', 'September,', 'October,', 'November,', 'December,'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  weekHeader: 'Wk',
  dateFormat: currentCultureFormat.dateFormat,
  firstDay: currentCultureFormat.firstDay,
  isRTL: false,
  showMonthAfterYear: false,
  yearSuffix: '',
  dateseparator: currentCultureFormat.dateSeparator
};
$.timepicker.regional['en-GB'] =
{
  timeFormat: currentCultureFormat.timeFormat,
  ampm: currentCultureFormat.ampm === "true"
};